/**
 * Sanitize HTML to prevent XSS attacks.
 * Strips dangerous elements and attributes.
 */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  // Remove dangerous elements
  div.querySelectorAll(
    'script, iframe, object, embed, form, input, textarea, select, button, svg, style, math, base, meta, link, template'
  ).forEach(el => el.remove());
  // Remove event handlers and dangerous attributes
  div.querySelectorAll('*').forEach(el => {
    for (const attr of Array.from(el.attributes)) {
      if (
        attr.name.startsWith('on') ||
        attr.name === 'style' ||
        (attr.name === 'href' && el.getAttribute('href')?.trimStart().toLowerCase().startsWith('javascript:')) ||
        (attr.name === 'src' && el.getAttribute('src')?.trimStart().toLowerCase().startsWith('javascript:')) ||
        (attr.name === 'action' && el.getAttribute('action')?.trimStart().toLowerCase().startsWith('javascript:')) ||
        attr.name === 'formaction' ||
        attr.name === 'srcdoc' ||
        attr.name === 'xlink:href'
      ) {
        el.removeAttribute(attr.name);
      }
    }
  });
  return div.innerHTML;
}
